import {MetricNumericalRenderer} from '../analyticsFormatHelpers';

export const renderPercentageValue: MetricNumericalRenderer = ({value}) =>
  `${(100 * value).toLocaleString(undefined, {minimumFractionDigits: 1, maximumFractionDigits: 1})}%`;
